<template>
  <label>{{ displayValue }}</label>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue() {
      switch (this.value) {
        case 'cpc':
          return 'CPC'
        case 'cpm':
          return 'CPM'
        case 'cost plus margin':
          return 'オークションCPM'
        case 'cpcv':
          return '完全視聴課金'
        default:
          return '----'
      }
    },
  },
}
</script>
